import { SaveChangesIcon } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';

interface SaveChanges {
  isOpen: boolean;
  onClose: () => void;
  actionButton?: () => void;
}

export const ModalSaveChanges: React.FC<SaveChanges> = ({ isOpen, onClose, actionButton }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('desejaSalvarAlteracoes')}
      title={t('salvarAlteracoes')}
      iconTitle={<SaveChangesIcon />}
      button1={t('confirmar')}
      button1Action={actionButton}
      button2={t('cancelar')}
      button2Action={onClose}
    />
  );
};
